module.exports = __webpack_public_path__ + "static/media/kh.cb8754fe.svg";